import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import PropTypes from "prop-types";
import { Badge, Col, Row, Select, Skeleton, Table } from "antd";
import "./index.css";
import { transactionsList } from "./data";
// import { useHistory } from "react-router";
import { BiCalendar } from "react-icons/bi";
import { loadPartiesTransaction } from "../../store/parties/actions";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";

const Transactions = (props) => {
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const partyListId = {
    organizationId: props.organizationId,
    partyId: props.partyId,
  };
  //api loader
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
    dispatch(loadPartiesTransaction(partyListId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Reducer state
  const { parties_transaction_list = [] } = useSelector(
    (state) => state.Parties
  );

  const tableData =
    parties_transaction_list && parties_transaction_list.length > 0
      ? parties_transaction_list.map((data, index) => {
          return {
            index: index + 1,
            quantity: data.Quantity,
            closingStock: data.closingStock,
            date: data.createdAt
              ? moment(data.createdAt).format("DD-MM-YYYY")
              : "-",
            itemId: data.itemId,
            organizationId: data.organizationId,
            serialIds: data.serialIds,
            invoiceNumber: data.invoiceNumber ? data.invoiceNumber : "--",
            transactionType: data.transactionType,
            status: (
              <Badge
                className={
                  data.status === "Paid"
                    ? "bg-[#edf6ef] font-semibold rounded-md text-[#49a563] p-2"
                    : "bg-[#f1e7e9] font-semibold rounded-md text-[#d01717] p-2"
                }
              >
                {data.status}
              </Badge>
            ),
            updatedAt: data.updatedAt
              ? moment(data.updatedAt).format("DD-MM-YYYY")
              : "-",
            _id: data._id,
          };
        })
      : [];

  //State data section
  // const [downloadLoading, setDownloadLoading] = useState(false);
  const [selectDays, setSelectDays] = useState([]);
  const [transactionType, setTransactionType] = useState([]);
  const HeaderData = [
    {
      key: "date",
      title: "Date",
      dataIndex: "date",
      sorter: (a, b) => a.date.length - b.date.length,
    },
    {
      key: "transactionType",
      title: "Transaction Type",
      dataIndex: "transactionType",
    },
    {
      key: "transactionNumber",
      title: "Transaction Number",
      dataIndex: "transactionNumber",
    },
    {
      key: "amount",
      title: "Amount",
      dataIndex: "amount",
      sorter: (a, b) => a.amount.length - b.amount.length,
    },

    {
      key: "status",
      title: "Status",
      dataIndex: "status",
    },
  ];

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Parties | Mbook</title>
        </MetaTags>
      </div>

      <Row className="border-solid rounded-sm bg-[#ffffff]">
        <Col span={24}>
          <Row>
            <Col span={8} className="mr-3">
              {loading ? (
                <Skeleton.Input
                  style={{
                    minWidth: "150%",
                    marginRight: "10px",
                  }}
                ></Skeleton.Input>
              ) : (
                <Select
                  suffixIcon={<BiCalendar size={16} />}
                  placeholder="Select Days"
                  value={selectDays}
                  onChange={(e) => setSelectDays(e)}
                  className="h-[40px] w-[100%]"
                />
              )}
            </Col>

            <Col span={8}>
              {loading ? (
                <Skeleton.Input
                  style={{
                    minWidth: "150%",
                    marginRight: "10px",
                  }}
                ></Skeleton.Input>
              ) : (
                <Select
                  placeholder="Select Transation Type"
                  options={transactionsList}
                  value={transactionType}
                  onChange={(e) => setTransactionType(e)}
                  className="h-[40px] w-[100%]"
                />
              )}
            </Col>
          </Row>
        </Col>
        <Col span={24} className="mt-4">
          <div>
            <Table
              style={{
                overflow: "hidden",
                cursor: "pointer",
              }}
              bordered
              columns={HeaderData}
              dataSource={tableData}
              sortDirections={"ascend"}
              loading={loading ? true : false}
              showSorterTooltip={"sorter-icon"}
              // onRow={partiesRoutes}
              // rowHoverable={partiesRoutes}
              // sticky=""

              // rowSelection={{
              //   type: selectionType,
              //   ...rowSelection,
              // }}
              // rowSelection={true}
              // rowSelection={partiesRoutes}
              scroll={{ y: 210 }}
            />
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};

Transactions.propTypes = {
  location: PropTypes.any,
  partyId: PropTypes.any,
  organizationId: PropTypes.any,
};

export default Transactions;
